// english

export default {
  my_base_title: 'My Base Information',
  my_base_btn: 'Update My Base Information',

  // form
  my_form_username: 'User Name',
  my_form_role: 'Role',
  my_form_avatar: 'Avatar',
  my_form_nickname: 'Nick Name',
  my_form_nickname_placeholder: 'please input your nick name',
  my_form_contact: 'Contact',
  my_form_contact_placeholder: 'please input your phone number',
  my_form_email: 'Email',
  my_form_email_placeholder: 'please input your email',
  my_form_customer: 'Belonged Cusomter',

  // email
  my_email_title: 'Email',
  my_email_tips: 'Once changed, the email associated with your account will change accordingly',
  my_email_btn: 'Update My Email',
  my_email_password_title: 'Verify password',
  my_email_password: 'Password',
  my_email_password_help: 'Please input your account password',

  // password
  my_password: 'Password',
  my_password_help:
    'After the password changed, you will need to log in again with the new password',
  my_password_current: 'Current Password',
  my_password_current_placeholder: 'please input your current password',
  my_password_new: 'New Password',
  my_password_new_help:
    'The password must be 8-32 bits, and contain large and small letters, numbers and special characters',
  my_password_new_placeholder: 'Please input your new password',
  my_password_new_confirm: 'Confirm New Password',
  my_password_new_confirm_placeholder: 'Please confirm your new password',
  my_password_btn: 'Update My Account Password',
  my_password_error1: 'The password is not strong enough',
  my_password_error2: 'The two password entries are inconsistent',
};
